import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DictionaryService } from 'app/mdm/terminology/dictionary/services/dictionary.service';
import { Dictionary } from 'app/mdm/terminology-lib/services/dictionary';

@Component({
  templateUrl: './dictionary-list.component.html',
})
export class DictionaryListComponent implements OnInit {
  public items: Array<Dictionary> = [];

  constructor(private dictionaryService: DictionaryService, private location: Location) {}

  ngOnInit(): void {
    this.dictionaryService.getDictionaries().subscribe((resp) => (this.items = resp));
  }

  goBack(): void {
    this.location.back();
  }
}
